import classNames from "classnames";

export const privacyPolicy = classNames(
    // Mobile
    "mobile:px-6",
    "mobile:text-xs",
    // Tablet
    "tablet:px-32",
    "tablet:text-sm",
    "tablet:pb-6",
    // All
    "w-auto",
    "text-center",

);

export const iframeStyling = classNames(
    // Mobile
    // Tablet
    "tablet:w-full",
    // All
    "flex",
    "flex-col",
    "items-center",
    "justify-center",
    "mb-10",
    "p-6"
)
